import React, { useState } from 'react';
import RecentVisits from './RecentVisits';
import UpcomingAppointments from './UpcomingAppointments';
import RecentBills from './RecentBills';
import { ChevronRight } from 'lucide-react';
import useWindowSize from '../../../utils/useWindowSize';
function TabSection() {
    const [tab, setTab] = useState("Visits");
    const tabs = ["Visits", "Appointments", "Billing"];
    const isMobile = useWindowSize().width < 640;

    const renderContent = () => {
        if (isMobile) {
            switch (tab) {
                case "Visits":
                    return <RecentVisits />;
                case "Appointments":
                    return <UpcomingAppointments />;
                case "Billing":
                    return <RecentBills />;
                default:
                    return null;
            }
        } else {
            return (
                <>
                    <RecentVisits />
                    <UpcomingAppointments />
                    <RecentBills />
                </>
            );
        }
    };
    return (
        <div className="bg-white  rounded-2xl shadow-[0_1px_4px_rgba(0,0,0,0.06)] border border-slate-100 overflow-hidden 
                    sm:bg-transparent sm:shadow-none sm:border-0">
            {/* tab bar */}

            <div className="flex sm:hidden items-center justify-between px-6 border-b border-slate-100">
                <div className="flex overflow-x-auto whitespace-nowrap overflow-y-hidden -mx-6 px-6">
                    {tabs.map(t => (
                        <button
                            key={t}
                            onClick={() => setTab(t)}
                            className={`px-4 py-3.5 text-sm font-semibold border-b-2 transition-colors -mb-px ${tab === t
                                ? "text-blue-500 border-blue-500"
                                : "text-gray-500 border-transparent"
                                }`}
                        >
                            {t}
                        </button>
                    ))}
                </div>
            </div>

            {/* 3-column content */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {renderContent()}
            </div>
        </div>
    );
}

export default TabSection;